<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="创建时间" prop="createDate">
        <el-date-picker v-model="form.createDate" value-format="yyyy-MM-dd" placeholder="请输入创建时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="创建人" prop="creator">
        <el-input v-model="form.creator" placeholder="请输入创建人" v-trim/>
      </el-form-item>
      <el-form-item label="编辑时间" prop="editDate">
        <el-date-picker v-model="form.editDate" value-format="yyyy-MM-dd" placeholder="请输入编辑时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="编辑人" prop="editor">
        <el-input v-model="form.editor" placeholder="请输入编辑人" v-trim/>
      </el-form-item>
      <el-form-item label="是否已删除 0未删除 1已删除" prop="isdeleted">
        <el-input v-model="form.isdeleted" placeholder="请输入是否已删除 0未删除 1已删除" v-trim/>
      </el-form-item>
      <el-form-item label="定价方案编码(关联price_param)" prop="pricePramId">
        <el-input v-model="form.pricePramId" placeholder="请输入定价方案编码(关联price_param)" v-trim/>
      </el-form-item>
      <el-form-item label="车辆类型编码(关联bike_types表）" prop="bikeTypeId">
        <el-input v-model="form.bikeTypeId" placeholder="请输入车辆类型编码(关联bike_types表）" v-trim/>
      </el-form-item>
      <el-form-item label="工作日起步时间（分钟）" prop="baseTime">
        <el-input v-model="form.baseTime" placeholder="请输入工作日起步时间（分钟）" v-trim/>
      </el-form-item>
      <el-form-item label="工作日起步价格（分）" prop="basePrice">
        <el-input v-model="form.basePrice" placeholder="请输入工作日起步价格（分）" v-trim/>
      </el-form-item>
      <el-form-item label="工作日超出时间（分钟）" prop="unitTime">
        <el-input v-model="form.unitTime" placeholder="请输入工作日超出时间（分钟）" v-trim/>
      </el-form-item>
      <el-form-item label="工作日超出价格（分）" prop="unitPrice">
        <el-input v-model="form.unitPrice" placeholder="请输入工作日超出价格（分）" v-trim/>
      </el-form-item>
      <el-form-item label="节假日起步时间（分钟）" prop="holidayBaseTime">
        <el-input v-model="form.holidayBaseTime" placeholder="请输入节假日起步时间（分钟）" v-trim/>
      </el-form-item>
      <el-form-item label="节假日起步价格（分）" prop="holidayBasePrice">
        <el-input v-model="form.holidayBasePrice" placeholder="请输入节假日起步价格（分）" v-trim/>
      </el-form-item>
      <el-form-item label="节假日超出时间（分钟）" prop="holidayUnitTime">
        <el-input v-model="form.holidayUnitTime" placeholder="请输入节假日超出时间（分钟）" v-trim/>
      </el-form-item>
      <el-form-item label="节假日超出时间单价（分）" prop="holidayUnitPrice">
        <el-input v-model="form.holidayUnitPrice" placeholder="请输入节假日超出时间单价（分）" v-trim/>
      </el-form-item>
      <el-form-item label="备注" prop="info">
        <el-input v-model="form.info" placeholder="请输入备注" v-trim/>
      </el-form-item>
      <el-form-item label="规则名称" prop="title">
        <el-input v-model="form.title" placeholder="请输入规则名称" v-trim/>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'OperaPricingDetailWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        createDate: '',
        creator: '',
        editDate: '',
        editor: '',
        isdeleted: '',
        pricePramId: '',
        bikeTypeId: '',
        baseTime: '',
        basePrice: '',
        unitTime: '',
        unitPrice: '',
        holidayBaseTime: '',
        holidayBasePrice: '',
        holidayUnitTime: '',
        holidayUnitPrice: '',
        info: '',
        title: ''
      },
      // 验证规则
      rules: {
      }
    }
  },
  created () {
    this.config({
      api: '/business/pricingDetail',
      'field.id': 'id'
    })
  }
}
</script>
